import type { SEOPropsType } from '..';

export const SEO_RETAIL_OFFER_CONTENT: SEOPropsType = {
  title: 'Personalized Prescription Skincare | Complete Your Routine',
  description:
    'Get a skincare formula personalized by experts for clinically proven results. Take the skin quiz and unlock your Curology offer–worth up to $50.',
};
